import React from 'react'
import {
  Box,
  Tabs,
  Tab,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material'
import UserDashboard from '../User/UserDashboard/UserDashboard'

function ProfileCard() {
  return <UserDashboard />
}

export default ProfileCard
